/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-mate.agent-message.error': 'チャットを再読み込み',
  'ai-mate.agent-message.error.aup-link-text': '利用規定',
  'ai-mate.agent-message.error.aup-one': 'そのプロンプトには応答できません。',
  'ai-mate.agent-message.error.aup-two':
    'プロンプトがアトラシアンの{link}に準拠していない可能性があります。別のプロンプトをお試しください。',
  'ai-mate.agent-message.error.copy-trace-id': 'トレース ID をコピー',
  'ai-mate.agent-message.error.network-error': 'ネットワークに問題が発生したようです。',
  'ai-mate.agent-message.error.resend': 'メッセージを再送信',
  'ai-mate.agent-message.error.trace-id': 'トレース ID: {traceId}',
  'ai-mate.browse-agents-view.close-button': 'エージェント ビューを閉じる',
  'ai-mate.browse-agents-view.header-title': 'エージェントを参照する',
  'ai-mate.chat-history.conversationLimit':
    '過去のチャットをお探しですか? AI がスムーズに動作するように、チャット履歴は 30 日経過すると消去されます。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': '最近私が投稿した Confluence ページを教えてください。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': '私に割り当てられた Jira チケットをすべて検索してください。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': '出張ポリシーとは何ですか?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4':
    'マーケティング キャンペーン向け Confluence ページの下書きを作ってください。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5':
    'プロジェクト タイムラインはどのようにして作成すればよいですか?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': '見込み顧客に送るフォローアップのメールを書いてください。',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-1': '`person` が作成したプル リクエストを教えてください。',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': 'エージェントを参照',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': 'Rovo エージェントとチャットする',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': 'このスペースについて',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': 'このスペースに関するインサイト',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': 'スペースの提案',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1':
    '私が書き込んだページに何か新しいアクティビティはありますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10':
    '私が公開したページに `ユーザー` はコメントしていますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': '`ページ` の重要ポイントは何ですか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': '私をメンションしている新規コメントはありますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3': 'このスペースで最近公開されたページを要約してください。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4': '先週以降に私がページに投稿した内容を要約してください。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5':
    'この `ページ` の内容を技術的にあまり難しくない表現で書き直してくれませんか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6':
    'プロジェクト管理用のゲーム プラン テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7':
    '顧客がよく遭遇する問題について私たちはどのような調査を行っていますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8': '今週私のチームの誰かが新しいページを公開しましたか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': '今週 `ユーザー` は新しいページを公開しましたか?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': 'このページの文章を改善してもらえますか?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2':
    'このページのエグゼクティブ サマリーを作成してください。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': '他の関連ページへのリンクを教えてください。',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': 'このページについて',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': 'このページのその他の情報',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': 'ページの提案',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': 'これを見ている私に要約してください。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': 'このページのコメントを要約してください。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3': 'このページについて初心者向けに説明してください。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4': 'このページを書いたのはどのチームの誰ですか?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5': '過去 1 週間でこのページに何か変更はありましたか?',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': 'このホワイトボードについて',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': 'このホワイトボードの詳細',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': 'このホワイトボードのインサイト',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': 'これを見ている私に要約してください。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2':
    'ここで確認できるパターンまたは傾向があればハイライトしてください。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3':
    'このホワイトボードでキャプチャされた主要なアクション アイテムまたは決定事項があれば特定してください。',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': '生産性の向上',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': '内容の下書き',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': '情報の検索',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': 'ユーザーの検索',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': '疑問の解決',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': '生産性の測定',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': '内容の言い換え',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': '最新情報の入手',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': '内容の要約',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>作成者</text>: {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': '{userName} さん、こんにちは',
  'ai-mate.chat-history.empty-state.intro-text-link-text': 'Rovo チャットと Rovo エージェントを使ってみましょう',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': '会話のきっかけから 1 つを選ぶか、何か質問してください。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': '今週更新された Jira 課題を探してください',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh':
    '今週更新された Jira 作業項目を探してください',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': '優先度が最も高い Jira 課題はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh':
    '優先度が最も高い Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': '私をメンションしているコメントがある Jira 課題はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh':
    '私をメンションしているコメントがある Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': '`Jira 課題` のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh':
    '`Jira 作業項目` のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': 'ユーザー ストーリー用の説明テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': 'この課題について',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': 'この作業項目について',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': 'この課題のその他の情報',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': 'この作業項目のその他の情報',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': 'この課題に関するインサイト',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': 'この作業項目に関するインサイト',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': '課題の提案',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': '作業項目の提案',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': 'この課題に似た Jira 課題はありますか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh':
    'この作業項目に似た Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': 'この説明文を改善するにはどうすればよいですか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': 'この課題にはどのようなラベルを追加すればよいですか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh':
    'この作業項目にはどのようなラベルを追加すればよいですか?',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': 'このプロジェクトについて',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': 'このプロジェクトに関するインサイト',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': 'このプロジェクトのその他の情報',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': 'プロジェクトの提案',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': 'しばらく着手されていない作業はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': '類似する Jira 課題を見つけてグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh':
    '類似する Jira 作業項目を見つけてグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11': '親課題に結び付けられていない Jira 課題はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    '親作業項目に結び付けられていない Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12':
    '`Jira 課題` の説明をベストプラクティスに合わせて書き直してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    '`Jira 作業項目` の説明をベストプラクティスに合わせて書き直してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': '`Jira 課題` のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    '`Jira 作業項目` のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14':
    'ユーザー ストーリー用の説明テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh':
    'ユーザー ストーリー用の説明テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': 'ブロックされている Jira 課題はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh':
    'ブロックされている Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    '現在 "進行中" の Jira 課題をリストして、担当者別にグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    '現在 "進行中" の Jira 作業項目をリストして、担当者別にグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': '`ユーザー` には何件の課題が割り当てられていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh':
    '`ユーザー` には何件の作業項目が割り当てられていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5':
    '`ユーザー` はこのスプリントの Jira 課題にコメントしていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    '`ユーザー` はこのスプリントの Jira 作業項目にコメントしていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': '未割り当ての Jira 課題はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh':
    '未割り当ての Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': 'オープンの状態が最も長い Jira 課題はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    'オープンの状態が最も長い Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': 'タスクが最も多いのは誰ですか?',
  'ai-mate.chat-history.empty-state.message':
    '答えを見つけたり、新しいアイデアを生み出したり、日々の仕事を効率化したりできます。',
  'ai-mate.chat-history.empty-state.suggestion1': '自分のチケットの中で期限切れになっているものはありますか?',
  'ai-mate.chat-history.empty-state.suggestion2': '次は何に取り組めばよいですか?',
  'ai-mate.chat-history.empty-state.suggestion3': '私の今週の作業のまとめを書いてください',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': '提案',
  'ai-mate.chat-history.message-research.research-completed-notification-body':
    '調査が完了し、閲覧できるようになりました。',
  'ai-mate.chat-history.message-research.research-completed-notification-title': 'Rovo チャットが調査を完了しました',
  'ai-mate.chat-history.message-research.research-expandable.collapse': '折りたたむ',
  'ai-mate.chat-history.message-research.research-expandable.expand': '展開',
  'ai-mate.chat-history.message-research.research-step-title-placeholder': '関連情報を検索しています...',
  'ai-mate.chat-history.message-research.sources-title': '{count, plural, other {{count} 件のソース}}',
  'ai-mate.chat-history.message-research.title': '詳細調査',
  'ai-mate.chat-history.message-research.view-sources-button-label': '{count, plural, other {{count} 件のソース}}',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'キャンセル',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': '確定',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button':
    'このアクションを完了する際に問題が発生しました',
  'ai-mate.chat-input.actions-button.label': '要素を挿入',
  'ai-mate.chat-input.add-a-link-button.label': 'リンクを追加',
  'ai-mate.chat-input.deep-research-button.label': '詳細調査',
  'ai-mate.chat-input.deleted-agent-icon-label': 'エージェントが削除されました',
  'ai-mate.chat-input.deleted-agent-start-new-chat': '新規チャットを開始',
  'ai-mate.chat-input.deleted-agent-warning': 'このエージェントは削除されました。',
  'ai-mate.chat-input.drag-and-drop-message':
    'より良い結果を得るには、ドラッグ アンド ドロップでコンテキストを追加してください',
  'ai-mate.chat-input.file-close-icon-label': 'ファイルを削除',
  'ai-mate.chat-input.file-error-icon-label': 'ファイルの読み込み中にエラーが発生しました',
  'ai-mate.chat-input.link-type-ahead-button.label': 'リンクを追加',
  'ai-mate.chat-input.mention-someone-button.label': 'ユーザーまたはチームをメンション',
  'ai-mate.chat-input.mention-type-ahead-button.label': 'ユーザーをメンション',
  'ai-mate.chat-input.open-chat-input-buttons-label': 'チャット入力を開くボタン',
  'ai-mate.chat-input.send-button.label': '送信',
  'ai-mate.chat-input.stop-generating-button.label': '生成を停止',
  'ai-mate.chat-input.store-user-messages.label': '回答の質を高めるためにこのメッセージを記録する',
  'ai-mate.chat-input.web-search-button.label': '検索',
  'ai-mate.chat-main-header.back-button.label': '戻る',
  'ai-mate.chat-main-header.copy-agent-link-button.label': 'リンクをコピー',
  'ai-mate.chat-main-header.default-agent-name': 'チャット',
  'ai-mate.chat-main-header.edit-agent-button.label': '編集',
  'ai-mate.chat-main-header.link-copied-to-profile': 'URL をコピーしました',
  'ai-mate.chat-view.chat-item.chat-delete-label': '削除',
  'ai-mate.chat-view.chat-item.chat-rename-label': '名前を変更',
  'ai-mate.chat-view.chat-item.options-button-label': 'チャット オプション',
  'ai-mate.content-renderer.profile-card.view-profile-button': 'プロファイルを表示',
  'ai-mate.content-renderer.view-code-button-label': '分析を表示',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'キャンセル',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    '削除しようとしている会話は存在しません。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': '削除',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    '会話 "{name}" を削除しますか?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    '会話の削除中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'この会話を削除してもよろしいですか? この操作は元に戻せません。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'キャンセル',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    '編集しようとしているチャンネルは存在しません。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': '名前',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    '会話の編集中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': '会話の編集',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    '名前が現在の名前と同じです。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': '保存',
  'ai-mate.conversation-list-view.back-button.label': '戻る',
  'ai-mate.conversation-list-view.close-chat-button.label': 'チャットを閉じる',
  'ai-mate.conversation-list-view.header-title': 'チャット履歴',
  'ai-mate.conversation-list-view.new-chat-button.label': '新規チャット',
  'ai-mate.conversation-list-view.no-chat': '該当する結果がありません',
  'ai-mate.conversation-list-view.search-input.placeholder': 'チャットを検索',
  'ai-mate.expander.hide-details': '詳細を非表示',
  'ai-mate.expander.show-details': '詳細をさらに表示',
  'ai-mate.footer.beta': 'ベータ版',
  'ai-mate.footer.info': 'コンテンツの質にはばらつきがある場合があります',
  'ai-mate.footer.info-truncated': 'コンテンツの質にはばらつきがある場合があります',
  'ai-mate.footer.info-updated':
    '表示されるコンテンツはユーザーの権限によって異なり、コンテンツの質にはばらつきがある場合があります',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.message-renderer.error': '問題が継続する場合は、アトラシアンにお知らせください。',
  'ai-mate.message-renderer.error-title': 'コンテンツを読み込めませんでした',
  'ai-mate.message-renderer.hide-sources': 'すべてのソースを非表示',
  'ai-mate.message-renderer.show-sources': '{count, plural, other {{count} 件のソースを表示}}',
  'ai-mate.message-renderer.sources.sources-title': 'ソース',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': '確認できませんでした。しばらくしてからもう一度お試しください。',
  'ai-mate.pubsub-listener.forge-auth-success-message': '確認できました。プロンプトを再送信してください。',
  'ai-mate.sidebar.agents-icon.text': 'エージェント',
  'ai-mate.sidebar.agents-icon.tooltip': 'Rovo エージェントを参照',
  'ai-mate.sidebar.chat-icon.text': 'チャット',
  'ai-mate.sidebar.chat-icon.tooltip': 'Rovo とチャット',
  'ai-mate.sidebar.debug-mode-icon.tooltip': 'デバッグ',
  'ai-mate.sidebar.get-help-icon.tooltip': 'サポート',
  'ai-mate.sidebar.give-feedback-icon.tooltip': 'フィードバックを送信',
  'ai-mate.sidebar.history-icon.text': '履歴',
  'ai-mate.sidebar.history-icon.tooltip': 'チャット履歴を表示',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-description':
    'ファイルの検証中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-title': 'ファイルの検証に失敗しました',
  'ai-mate.upload-files-to-conversation.file-invalid-icon-label': '無効なファイル',
  'ai-mate.upload-files-to-conversation.invalid-files-description':
    '{count, plural, other {次のファイルはサポートされていません: "{fileNames}" 理由: {reasons}}}',
  'ai-mate.upload-files-to-conversation.invalid-files-title':
    '{count, plural, other {サポートされていないファイル タイプが {count,number} 件あります}}',
  'ai-mate.upload-files-to-conversation.unknown-error':
    'ファイルのアップロード中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.upload-files-to-conversation.unsupported-file': 'サポートされていないファイル タイプです',
  'ai-mate.upload-files-to-conversation.validation-error-file-name-missing': 'ファイル名がありません',
  'ai-mate.upload-files-to-conversation.validation-error-file-too-large': 'ファイル サイズが大きすぎます',
  'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type':
    'ファイル タイプがサポートされていません',
  'ai-mate.upload-files-to-conversation.validation-error-missing-error-code': '検証結果が不明です',
  'ai-mate.upload-files-to-conversation.validation-error-not-found': '検証結果が見つかりません',
  'ai-mate.upload-files-to-conversation.validation-error-unknown-error': 'ファイルの検証に失敗しました (原因不明)',
  'chat-history.rate-limit-warning': '{secondsRemaining, plural, other {{secondsRemaining,number} 秒お待ちください}}',
  'chat-history.rate-limit-warning-description': 'メッセージの送信が速すぎます。しばらくお待ちください。',
  'chatHistory.storeAssistant.badResponseLabel': '悪い返答',
  'chatHistory.storeAssistant.copyResponseLabel': 'コピー',
  'chatHistory.storeAssistant.goodResponseLabel': 'よい返答',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': 'このコンテキストを使用',
  'rovo-chat.data-sculptor-modal.cancel': 'キャンセル',
  'rovo-chat.data-sculptor-modal.no-data': 'データなし',
  'rovo-chat.data-sculptor-modal.title': '分析',
  'rovo-chat.file-upload-button.label': 'アップロードするファイル',
  'rovo-chat.file-upload-button.max-files-label':
    '{maxFiles, plural, other {ファイル数の上限 {maxFiles,number} 件に達しました}}',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'ドラッグ アンド ドロップでコンテキストを追加してください',
  'rovo-chat.message-file.icon-label': 'ファイル',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': 'ページに挿入',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': '挿入',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': '課題に挿入',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': '選択内容を置換',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    '現在のコンテキストではこの機能はサポートされません。ページでテキストを選択するか、書き込むか、編集してみてください。',
  'rovo-chat.store-assistant.sources-title': 'ソース:',
};
